import React from "react";
import { useTranslation } from "react-i18next";
import { Check, CheckCheck, Trash2 } from "lucide-react";
import { Button } from "../ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

const NotificationsHeader = ({
  filter, setFilter, typeFilter, setTypeFilter,
  selectedNotifications, handleMarkSelectedAsRead, handleMarkAllAsRead, handleDeleteAllRead,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        <Select value={filter} onValueChange={setFilter}>
          <SelectTrigger className="w-[140px]"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{t("planning.legacy.notifications.filters.all")}</SelectItem>
            <SelectItem value="unread">{t("planning.legacy.notifications.filters.unread")}</SelectItem>
            <SelectItem value="read">{t("planning.legacy.notifications.filters.read")}</SelectItem>
          </SelectContent>
        </Select>

        <Select value={typeFilter} onValueChange={setTypeFilter}>
          <SelectTrigger className="w-[180px]"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{t("planning.legacy.notifications.types.all")}</SelectItem>
            <SelectItem value="SCHEDULE_CHANGED">{t("planning.legacy.notifications.types.scheduleChanged")}</SelectItem>
            <SelectItem value="OVERRIDE_PENDING">{t("planning.legacy.notifications.types.overridePending")}</SelectItem>
            <SelectItem value="OVERRIDE_APPROVED">{t("planning.legacy.notifications.types.overrideApproved")}</SelectItem>
            <SelectItem value="OVERRIDE_REJECTED">{t("planning.legacy.notifications.types.overrideRejected")}</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center gap-2">
        {selectedNotifications.length > 0 && (
          <Button variant="outline" size="sm" onClick={handleMarkSelectedAsRead}>
            <Check className="h-4 w-4 mr-1" />
            {t("planning.legacy.notifications.actions.markSelected")}
          </Button>
        )}
        <Button variant="outline" size="sm" onClick={handleMarkAllAsRead}>
          <CheckCheck className="h-4 w-4 mr-1" />
          {t("planning.legacy.notifications.actions.markAllRead")}
        </Button>
        <Button variant="outline" size="sm" onClick={handleDeleteAllRead}>
          <Trash2 className="h-4 w-4 mr-1" />
          {t("planning.legacy.notifications.actions.deleteRead")}
        </Button>
      </div>
    </div>
  );
};

export default NotificationsHeader;
